module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Befund.1d91371f.svg";